import React from 'react';
import { Table } from 'semantic-ui-react';
import { map } from 'ramda';
import { withNamespaces } from 'react-i18next';
import { generate } from 'shortid';


const TableHeader = (props) => {
  const { t } = props;

  const cols = [
    'num',
    'event',
    'competition_name',
    'teamName',
    'robotName',
    'orig_price',
    'discount',
    'sale_price',
    'tax',
    'total'
  ];

  return (
    <Table.Header>
      <Table.Row>
        { map(key =>
              <Table.HeaderCell key={generate()} collapsing>
                {t('private:po:teams.' + key)}
              </Table.HeaderCell>, cols)}
      </Table.Row>
    </Table.Header>
  );
};

export default withNamespaces(['private'])(TableHeader);



// WEBPACK FOOTER //
// ./src/private/common/components/TransactionTable/Header.js